import i18n from 'i18next'
import React from 'react'

const QuoteResultLabel = ({label}) => {
  return (
    <div className={`quote-result-label-${label}`}>
      <p>{i18n.t(`Components.QuoteResultLabel.${label}`)}</p>
    </div>
  )
}

export default QuoteResultLabel
